/** Meta Help Center URLs for channel connect wizard (external links only). */
export const CHANNEL_CONNECT_HELP_LINKS = {
  instagramProfessional:
    "https://www.facebook.com/help/instagram/502981923235522",
  instagramFacebookPage:
    "https://www.facebook.com/help/instagram/114002221237616",
  instagramMessageAccess:
    "https://www.facebook.com/help/instagram/1668287523520883",
  whatsappBusiness: "https://www.whatsapp.com/business",
  whatsappMetaAdmin: "https://www.facebook.com/business/help",
} as const;
